import React, { FC, useState, ChangeEvent, useCallback } from 'react';
import { Input, Spin } from 'antd';
import { debounce } from 'lodash';
import { LoadingOutlined } from '@ant-design/icons';

import { SearchIcon } from '~/img';

import './styles.less';
import { usePath } from '~/hooks';

export interface PageHeaderProps {
  heading: React.ReactNode;
  searchPlaceholder?: string;
  onSearch?: (text: string) => void;
  queryParam?: string;
  showSearch?: boolean;
  isFetching?: boolean;
  actions?: JSX.Element;
}

const PageHeader: FC<PageHeaderProps> = (props) => {
  const {
    heading = '???',
    searchPlaceholder = 'Search',
    onSearch,
    showSearch = true,
    queryParam = 'text',
    isFetching,
    actions,
  } = props;
  const {
    params: { filter },
  } = usePath();

  const [state, setState] = useState<string>((filter && filter[queryParam]) || '');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setState(text);
    debouncedHandleSearch(text);
  };
  const handleSearch = () => {
    if (onSearch) onSearch(state);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleSearch = useCallback(
    debounce((text: string) => {
      if (onSearch) onSearch(text);
    }, 500),
    [onSearch]
  );

  return (
    <div className="PageHeader">
      <div className="PageHeader-FirstLine">
        <div className="PageHeader-Heading">
          {heading} {isFetching && <FetchingIndicator />}
        </div>
        {actions}
      </div>
      {showSearch && (
        <Input
          className="PageHeader-Input"
          size="large"
          value={state}
          placeholder={searchPlaceholder}
          onChange={handleChange}
          prefix={<SearchIcon onClick={handleSearch} />}
          allowClear
        />
      )}
    </div>
  );
};

const FetchingIndicator = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
  return <Spin indicator={antIcon} />;
};

export default PageHeader;
